import querystring from 'querystring';
import {
  Link,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from 'react-router-dom';

import enums from '../../helpers/enums';
import formatters from '../../helpers/formatters';
import useApi from '../../helpers/useApi';

import CustomPie from '../../components/CustomPie';
import TableInfo from '../../components/TableInfo';

import Timeline from './Timeline';

const Jig = () => {
  const { path, url } = useRouteMatch();

  return (
    <>
      <h1>Single jig statistics</h1>
      <div className='navigation-container'>
        <Link to={`${url}`} className='navigation-item'>Overview</Link>
        <Link to={`${url}/timeline`} className='navigation-item'>Timeline</Link>
      </div>
      <Switch>
        <Route exact path={`${path}/`}>
          <Overview />
        </Route>
        <Route path={`${path}/timeline`}>
          <Timeline />
        </Route>
      </Switch>
    </>
  );
};

export default Jig;

const Overview = () => {
  const history = useHistory();

  const { isLoading, data } = useApi('analytics/production/jig/overview');

  if (isLoading) {
    return (
      <div>Loading....</div>
    );
  }

  const rows = [
    {
      label: 'UUID',
      value: data.jig.id,
    },
    {
      label: 'Factory',
      value: enums.factory[data.jig.factory_id].label,
    },
    {
      label: 'Total tests',
      value: data.jig.count_tests,
      onClick: () => history.push({
        pathname: '/analytics/production/events',
        search: querystring.stringify({ jigId: data.jig.id }),
      }),
    },
    {
      label: 'Passed tests',
      value: data.jig.count_tests_passed,
      onClick: () => history.push({
        pathname: '/analytics/production/events',
        search: querystring.stringify({ jigId: data.jig.id, testResult: ['passed'] }),
      }),
    },
    {
      label: 'Failed tests',
      value: data.jig.count_tests_failed,
      onClick: () => history.push({
        pathname: '/analytics/production/events',
        search: querystring.stringify({ jigId: data.jig.id, testResult: ['failed'] }),
      }),
    },
    {
      label: 'Module count',
      value: data.jig.count_modules,
      onClick: () => history.push({
        pathname: '/analytics/production/modules',
        search: querystring.stringify({ jigId: data.jig.id }),
      }),
    },
    {
      label: 'Avg. tests per test module',
      value: formatters.float(data.jig.avg_tests_per_module),
    },
  ];

  return (
    <>
      <div className='stats-main-container'>
        <div className='charts-container'>
          <TableInfo rows={rows} />
          <CustomPie
            title='Passed vs. failed tests'
            data={[
              {
                name: 'passed',
                count: data.jig.count_tests_passed,
              },
              {
                name: 'failed',
                count: data.jig.count_tests_failed,
              },
            ]}
            dataKey='count'
            nameKey='name'
            enumName='testResult'
          />
          <CustomPie
            title='Tests per module'
            data={data.statsOverviewPerModule}
            dataKey='count'
            nameKey='module_num'
            enumName='module'
          />
        </div>
      </div>
    </>
  );
};
